import { useEffect } from "react";
import { applySeo, canonicalPath, metaForPath } from "../../seo/seo";

export default function SEO({ path, meta, metaByPath = {} }) {
  useEffect(() => {
    const currentPath = canonicalPath(path || window.location.pathname);
    applySeo(meta || metaByPath[currentPath] || metaForPath(currentPath));
  }, [meta, metaByPath, path]);

  return null;
}
